<h2 mat-dialog-title>Attention</h2>
<mat-dialog-content>
  <p>Cette application est optimisée pour un usage sur tablette.</p>
  <p>
    L’utilisation sur d’autres appareils (ordinateur, téléphone, etc.) peut
    entraîner des dysfonctionnements d’affichage.
  </p>
  <p>
    Pour une meilleure expérience, veuillez vous connecter depuis une tablette.
  </p>
  <p>
    Si vous utilisez déjà une tablette, assurez-vous d’être en
    <strong>mode horizontal</strong> pour un affichage optimal.
  </p>
  <div class="icons">
    <mat-icon fontSet="material-symbols-outlined">tablet</mat-icon>
    <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
    <mat-icon
      fontSet="material-symbols-outlined"
      style="transform: rotate(90deg)"
    >
      tablet
    </mat-icon>
    <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
